import * as React from 'react';
/**
 *
 * Original name: Family Room
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=47294%3A3728
 *
 */
export const FamilyRoomLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M18.35 9.025c-.19-1.465-.695-2.615-1.505-3.43C15.785 4.535 14.155 4 11.995 4c-2.16 0-3.79.535-4.85 1.595C6.33 6.41 5.83 7.56 5.64 9.025H4v8.5h1.5v2H7v-2h10v2h1.5v-2H20v-8.5h-1.65ZM8.21 6.655C8.98 5.885 10.25 5.5 12 5.5s3.02.39 3.79 1.155c.555.555.905 1.375 1.065 2.44a2.25 2.25 0 0 0-1.72 2.18v1.34H8.87v-1.34a2.25 2.25 0 0 0-1.72-2.18c.155-1.065.51-1.885 1.065-2.44H8.21Zm-2.71 3.87h1.115c.415 0 .75.335.75.75v2.84h9.265v-2.84c0-.415.335-.75.75-.75h1.115v5.5H5.5v-5.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
